export default __webpack_public_path__ + "static/media/trova-PC.8a2a06cb.svg";